import { div } from '../../scripts/dom-builder.js';
import getBlockOption from '../../scripts/utils/get-block-option.js';
import { DEFAULT_COLOR, FIELD_INDEX } from './heading.constants.js';
import { applyPartialColor } from './utils/apply-partial-color.js';

export default async function decorate(block) {
  const getCell = (index) => block.children[index]?.firstElementChild;
  const getValue = (index) => getCell(index)?.textContent?.trim() ?? '';

  // AEM renders <h2>text</h2> via field collapse (headingContent_heading + headingContent_headingType).
  // If headingContent_short is filled, AEM appends <p>short</p> in the same cell.
  // NOTE: ToC reads the <p> sibling after <h2>/<h3> as the short label for the navigation list.
  // Changing this DOM structure will affect toc.js behavior — see the toc block.
  const headingCell = getCell(FIELD_INDEX.HEADING_CONTENT);
  const headingEl = headingCell?.querySelector(':is(h1, h2, h3, h4, h5, h6)');

  if (!headingEl) {
    return;
  }

  const tocSibling =
    headingEl.nextElementSibling?.tagName === 'P'
      ? headingEl.nextElementSibling
      : null;

  if (tocSibling) {
    tocSibling.classList.add('heading__toc-label');
  }

  const wordsToColor = getValue(FIELD_INDEX.WORDS_TO_COLOR);
  const wordColor = getBlockOption(
    block.classList,
    'word-color-',
    DEFAULT_COLOR,
  );

  headingEl.classList.add('heading__text');

  applyPartialColor(headingEl, wordsToColor, wordColor);

  const wrapper = div(
    { class: 'heading__wrapper' },
    headingEl,
    ...(tocSibling ? [tocSibling] : []),
  );

  block.replaceChildren(wrapper);
}
